import {
  Baby,
  Banknote,
  BedDouble,
  Beef,
  Beer,
  Bike,
  Book,
  Briefcase,
  Bus,
  Cake,
  Camera,
  Car,
  Cat,
  Church,
  CircleDollarSign,
  Coffee,
  CreditCard,
  Dog,
  Dumbbell,
  Film,
  Fuel,
  Gamepad2,
  Gem,
  Gift,
  GraduationCap,
  HandCoins,
  Hammer,
  Heart,
  Home,
  Landmark,
  Music,
  Palette,
  Pizza,
  Scissors,
  Sofa,
  Sprout,
  TrainFront,
  TreePine,
  Tv,
  Umbrella,
  Wallet,
  Utensils,
  Plane,
  PawPrint,
  PiggyBank,
  Pill,
  Receipt,
  Shirt,
  ShoppingBag,
  ShoppingCart,
  Smartphone,
  Sparkles,
  Stethoscope,
  Ticket,
  TrendingUp,
  Wifi,
  Wine,
  Wrench,
  Zap,
  Tag as TagIcon,
  type LucideIcon,
} from 'lucide-react';

/**
 * Set curado de ícones lucide (chaves em kebab-case = nome oficial do lucide).
 * É a fonte única para IconPicker (o que o usuário escolhe) e CategoryIcon (como renderiza).
 */
export const ICON_REGISTRY: Record<string, LucideIcon> = {
  'shopping-cart': ShoppingCart,
  'shopping-bag': ShoppingBag,
  utensils: Utensils,
  coffee: Coffee,
  car: Car,
  bus: Bus,
  fuel: Fuel,
  plane: Plane,
  home: Home,
  zap: Zap,
  smartphone: Smartphone,
  heart: Heart,
  stethoscope: Stethoscope,
  pill: Pill,
  dumbbell: Dumbbell,
  'graduation-cap': GraduationCap,
  book: Book,
  film: Film,
  'gamepad-2': Gamepad2,
  gift: Gift,
  shirt: Shirt,
  'paw-print': PawPrint,
  wrench: Wrench,
  receipt: Receipt,
  ticket: Ticket,
  sparkles: Sparkles,
  'trending-up': TrendingUp,
  'piggy-bank': PiggyBank,
  banknote: Banknote,
  wallet: Wallet,
  landmark: Landmark,
  'credit-card': CreditCard,
  'circle-dollar-sign': CircleDollarSign,
  'hand-coins': HandCoins,
  briefcase: Briefcase,
  cake: Cake,
  pizza: Pizza,
  beef: Beef,
  beer: Beer,
  wine: Wine,
  bike: Bike,
  'train-front': TrainFront,
  baby: Baby,
  dog: Dog,
  cat: Cat,
  'bed-double': BedDouble,
  sofa: Sofa,
  hammer: Hammer,
  palette: Palette,
  camera: Camera,
  gem: Gem,
  music: Music,
  scissors: Scissors,
  church: Church,
  'tree-pine': TreePine,
  sprout: Sprout,
  umbrella: Umbrella,
  tv: Tv,
  wifi: Wifi,
};

/** Ordem estável para a grade do IconPicker. */
export const CURATED_ICON_NAMES: string[] = Object.keys(ICON_REGISTRY);

/** Ícone default quando o nome não está no set (dados legados / sistema). */
export const FALLBACK_ICON: LucideIcon = TagIcon;

/** Resolve um nome de ícone para o componente lucide (fallback seguro). */
export function resolveIcon(name: string | null | undefined): LucideIcon {
  if (!name) return FALLBACK_ICON;
  return ICON_REGISTRY[name] ?? FALLBACK_ICON;
}
